import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { DashboardLayout } from '../../components/layout/DashboardLayout'
import { ServiceCategoryTabs } from './components/ServiceCategoryTabs'
import { ServicesGrid } from './components/ServicesGrid'
import { Breadcrumb } from '../../components/ui/Breadcrumb'
import { shellAssets } from '../../constants/assets'
import { dashboardRoutes } from '../../constants/routes'
import { useServices } from '../../hooks/useServices'

import { FleetsGrid } from './components/FleetsGrid'

const currentUser = {
  name: 'Admin',
  email: 'Admin@123gmail.com',
  avatar: shellAssets.avatar,
}

const ServicesPage = () => {
  const {
    visible,
    category,
    setCategory,
    toggleActive,
    fleetRecords,
    toggleFleetActive,
    updatingIds,
  } = useServices()

  const navigate = useNavigate()

  const onEdit = useCallback(
    (id: string) => {
      if (['day-trips', 'ski-transfers', 'private-van-tours'].includes(category)) {
        navigate(dashboardRoutes.serviceEdit.replace(':id', id))
      } else {
        window.alert(`Connect edit for ${id} once the API exists.`)
      }
    },
    [category, navigate],
  )

  const onCreate = useCallback(
    () => {
      if (['day-trips', 'ski-transfers', 'private-van-tours'].includes(category)) {
        navigate(dashboardRoutes.serviceNew.replace(':category', category))
      } else {
        window.alert('Connect this to the service form once the API exists.')
      }
    },
    [category, navigate],
  )

  const onFleetEdit = useCallback(
    (id: string) => navigate(dashboardRoutes.fleetEdit.replace(':id', id)),
    [navigate],
  )

  const onFleetCreate = useCallback(
    () => navigate(dashboardRoutes.fleetNew),
    [navigate],
  )

  const onVehicleCategoriesBrands = useCallback(
    () => navigate(dashboardRoutes.vehicleCategoriesBrands),
    [navigate],
  )

  const onView = useCallback(
    (id: string) => window.alert(`Connect view for ${id} once the API exists.`),
    [],
  )

  return (
    <DashboardLayout
      activeNavId="services"
      contentGap={15}
      subtitle={
        <Breadcrumb
          items={[{ label: 'Dashboard', path: dashboardRoutes.overview }, { label: 'Services' }]}
        />
      }
      title="Services"
      user={currentUser}
    >
      <div className="flex min-h-0 flex-col gap-[24px] lg:h-[calc(100dvh-175px)] lg:overflow-hidden">
  {/* Fixed tabs and management button */}
  <div className="flex shrink-0 flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
    <ServiceCategoryTabs
      onChange={setCategory}
      value={category}
    />

    <button
      type="button"
      onClick={onVehicleCategoriesBrands}
      className="inline-flex items-center justify-center rounded-[12px] bg-[#334E1C] px-4 py-3 text-[13px] font-semibold text-white transition hover:bg-[#253914]"
    >
      Manage Vehicle Categories & Brands
    </button>
  </div>

  {/* Only service/fleet cards scroll */}
  <div className="min-h-0 flex-1 pr-[6px] lg:overflow-y-auto lg:overscroll-contain">
    {category === 'fleets' ? (
      <FleetsGrid
        onCreate={onFleetCreate}
        onEdit={onFleetEdit}
        onToggleActive={toggleFleetActive}
        updatingIds={updatingIds}
        fleets={fleetRecords}
      />
    ) : (
      <ServicesGrid
        onCreate={onCreate}
        onEdit={onEdit}
        onToggleActive={toggleActive}
        onView={onView}
        updatingIds={updatingIds}
        services={visible}
      />
    )}
  </div>
</div>
    </DashboardLayout>
  )
}

export default ServicesPage
